<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_4"></a>For my girls</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?543959d3